module.exports = __webpack_public_path__ + "static/media/Rengar.95bfb2a3.png";